export default {"src":"/_next/static/image/public/images/flags/flag_379.05e1c76a60de95c78fc322776076f474.svg","height":16,"width":24};